/** @file Deletes an IK constraint together with its timelines in every animation. */
import { defineRemove } from '../_shared/defineRemove';

/** ik.delete: the defineRemove factory; removeEntity drops the constraint's timelines with it. */
export const command = defineRemove({ domain: 'ik', kind: 'ik', description: 'Delete an IK constraint (its keys in every animation are removed with it).' });
